import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr11 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        за безопасна работа със стационарни и подвижни двигател-генератори/дизелагрегати
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. До работа с двигател-генератори </b>се допускат лица с необходимата техническа
        правоспособност, които са преминали съответното обучение и инструктаж за безопасна работа и
        които притежават не по-ниска от трета квалификационна група по електро безопасност.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При работа да се използват одобрените </b>и предоставени съобразно степента на риска
        лични предпазни средства, за вида, употребата и начина на съхранение на които работещите са
        инструктирани (и обучени за използването на тези ЛПС, за които това е необходимо).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с неизправни лични предпазни средства и с такива с изтекъл срок на годност и на
        периодична проверка.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b> 4. Да се следи принудителната вентилация </b>в помещението, в което е разположен
        стационарен дизелагрегат, да се включва веднага при задействане на агрегата и по време на
        неговата работа.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. Да се следи за изправността</b> на заглушителите и тръбата, която отвежда изгорелите
        газове от агрегата над покрива. Димоотводът да бъде топлоизолиран в зоната на човешкия
        обсег.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. Ръчното наливане на гориво в резервоара</b> да става само при спрян двигател.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          7. <span style={styles.warning}>Забранява се </span>
        </b>
        употребата на етилиран бензин за двигатели с вътрешно горене.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          8. <span style={styles.warning}>Забранява се</span>{' '}
        </b>
        по време на работа на агрегата:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - почистването и смазването на частите му;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - сменянето на трансмисионните ремъци;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - влизането зад огражденията;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - ремонтирането на двигателя и спомагателните съоръжения.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>9. При спиране на агрегата за ремонт</b>, преглед или почистване да се взимат мерки срещу
        погрешно включване или произволно движение. На двигателя с дистанционно и автоматично
        управление да се изключи управлението, като се поставят табелки с предупредителни надписи в
        местата на пускане: &quot;Не включвай! Работят хора&quot;.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. При основен ремонт на двигателите </b>да се обръща особено внимание на правилното
        законтряне на гайките на мотовилковите болтове и закрепването на коляновия вал.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Помещенията, в които са разположени стационарните агрегати</b>, да се поддържат
        чисти.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. При работа с подвижни агрегати </b>да се спазват следните изисквания:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - агрегатите да се поставят хоризонтално върху твърда негорима подложка;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се разполагат на безопасно разстояние от леснозапалими материали;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - корпусите им да се заземяват.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          13. <span style={styles.warning}>Забранява се </span>
        </b>
        експлоатацията на подвижен агрегат без да е заземен.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          14. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с агрегата при свалени предпазни ограждения.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          15. <span style={styles.warning}>Забранява се </span>
        </b>
        подгряването на горивопроводната система на агрегата с бензинови лампи, факли и др.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          16. <span style={styles.warning}>Забранява се </span>
        </b>
        оставянето на работещ агрегат без наблюдение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>17. Разлятото по пода </b>гориво или смазочно масло да се почиства веднага. Материалите
        за бърсане и почистване да се съхраняват в закрит метален сандък.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>18. Пространството около дизелагрегата </b>да бъде свободно от материали.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          19. <span style={styles.warning}>Забранява се </span>
        </b>
        пушенето или ползването на открит огън в близост до агрегата.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>20. При пожар незабавно </b>да се прекрати достъпът на гориво и агрегатът да се спре.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>21. Персоналът да е запознат </b>с начина на гасене и безопасната работа с
        пожарогасителните уреди, с които е оборудван обектът.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr11;
